import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { ServiceAppService } from './../../../../security/service-app.service';
import { IFiltros, ITotaisHistorico } from '../interface-apuracao-vdm';

@Component({
  selector: 'app-apuracao-vdm-historico',
  templateUrl: './apuracao-vdm-historico.component.html',
  styleUrls: ['./apuracao-vdm-historico.component.scss']
})
export class ApuracaoVdmHistoricoComponent implements OnInit {
  cols: any[];
  frozenCols: any[];
  colsFooter: any[];
  dados: any[];
  loading: boolean;

  totaisHistorico: ITotaisHistorico = {
    filtroAno: 0,
    totalAbrGap: 0,
    totalAbrObjetivo: 0,
    totalAbrPercent: 0,
    totalAbrRealizado: 0,
    totalAgoGap: 0,
    totalAgoObjetivo: 0,
    totalAgoPercent: 0,
    totalAgoRealizado: 0,
    totalDezGap: 0,
    totalDezObjetivo: 0,
    totalDezPercent: 0,
    totalDezRealizado: 0,
    totalFevGap: 0,
    totalFevObjetivo: 0,
    totalFevPercent: 0,
    totalFevRealizado: 0,
    totalJanGap: 0,
    totalJanObjetivo: 0,
    totalJanPercent: 0,
    totalJanRealizado: 0,
    totalJulGap: 0,
    totalJulObjetivo: 0,
    totalJulPercent: 0,
    totalJulRealizado: 0,
    totalJunGap: 0,
    totalJunObjetivo: 0,
    totalJunPercent: 0,
    totalJunRealizado: 0,
    totalMaiGap: 0,
    totalMaiObjetivo: 0,
    totalMaiPercent: 0,
    totalMaiRealizado: 0,
    totalMarGap: 0,
    totalMarObjetivo: 0,
    totalMarPercent: 0,
    totalMarRealizado: 0,
    totalNovGap: 0,
    totalNovObjetivo: 0,
    totalNovPercent: 0,
    totalNovRealizado: 0,
    totalOutGap: 0,
    totalOutObjetivo: 0,
    totalOutPercent: 0,
    totalOutRealizado: 0,
    totalQ1Gap: 0,
    totalQ1Objetivo: 0,
    totalQ1Percent: 0,
    totalQ1Realizado: 0,
    totalQ2Gap: 0,
    totalQ2Objetivo: 0,
    totalQ2Percent: 0,
    totalQ2Realizado: 0,
    totalQ3Gap: 0,
    totalQ3Objetivo: 0,
    totalQ3Percent: 0,
    totalQ3Realizado: 0,
    totalQ4Gap: 0,
    totalQ4Objetivo: 0,
    totalQ4Percent: 0,
    totalQ4Realizado: 0,
    totalSetGap: 0,
    totalSetObjetivo: 0,
    totalSetPercent: 0,
    totalSetRealizado: 0,
  }

  @Input() filtros: IFiltros;
  @ViewChild('dt') dt: Table;
  constructor(private service: ServiceAppService) { }

  ngOnInit(): void {
    this.retornaDados();

    this.cols = [
      { field: 'codDealer', header: 'Dealer', width: 'width:120px' },
      { field: 'nomeDealer', header: 'Nome', width: 'width:120px' },
      { field: 'abrRealizado', header: 'Realizado / Abr', width: 'width:142px' },
      { field: 'abrObjetivo', header: 'Objetivo / Abr', width: 'width:135px' },
      { field: 'abrGap', header: 'Gap / Abr', width: 'width:120px' },
      { field: 'abrPercent', header: '% / Abr', width: 'width:120px' },
      { field: 'maiRealizado', header: 'Realizado / Mai', width: 'width:142px' },
      { field: 'maiObjetivo', header: 'Objetivo / Mai', width: 'width:135px' },
      { field: 'maiGap', header: 'Gap / Mai', width: 'width:120px' },
      { field: 'maiPercent', header: '% / Mai', width: 'width:120px' },
      { field: 'junRealizado', header: 'Realizado / Jun', width: 'width:142px' },
      { field: 'junObjetivo', header: 'Objetivo / Jun', width: 'width:135px' },
      { field: 'junGap', header: 'Gap / Jun', width: 'width:120px' },
      { field: 'junPercent', header: '% / Jun', width: 'width:120px' },
      { field: 'q1Realizado', header: 'Realizado / Q1', width: 'width:142px' },
      { field: 'q1Objetivo', header: 'Objetivo / Q1', width: 'width:135px' },
      { field: 'q1Gap', header: 'Gap / Q1', width: 'width:120px' },
      { field: 'q1Percent', header: '% / Q1', width: 'width:120px' },
      { field: 'julRealizado', header: 'Realizado / Jul', width: 'width:142px' },
      { field: 'julObjetivo', header: 'Objetivo / Jul', width: 'width:135px' },
      { field: 'julGap', header: 'Gap / Jul', width: 'width:120px' },
      { field: 'julPercent', header: '% / Jul', width: 'width:120px' },
      { field: 'agoRealizado', header: 'Realizado / Ago', width: 'width:145px' },
      { field: 'agoObjetivo', header: 'Objetivo / Ago', width: 'width:140px' },
      { field: 'agoGap', header: 'Gap / Ago', width: 'width:120px' },
      { field: 'agoPercent', header: '% / Ago', width: 'width:120px' },
      { field: 'setRealizado', header: 'Realizado / Set', width: 'width:142px' },
      { field: 'setObjetivo', header: 'Objetivo / Set', width: 'width:135px' },
      { field: 'setGap', header: 'Gap / Set', width: 'width:120px' },
      { field: 'setPercent', header: '% / Set', width: 'width:120px' },
      { field: 'q2Realizado', header: 'Realizado / Q2', width: 'width:142px' },
      { field: 'q2Objetivo', header: 'Objetivo / Q2', width: 'width:135px' },
      { field: 'q2Gap', header: 'Gap / Q2', width: 'width:120px' },
      { field: 'q2Percent', header: '% / Q2', width: 'width:120px' },
      { field: 'outRealizado', header: 'Realizado / Out', width: 'width:142px' },
      { field: 'outObjetivo', header: 'Objetivo / Out', width: 'width:135px' },
      { field: 'outGap', header: 'Gap / Out', width: 'width:120px' },
      { field: 'outPercent', header: '% / Out', width: 'width:120px' },
      { field: 'novRealizado', header: 'Realizado / Nov', width: 'width:145px' },
      { field: 'novObjetivo', header: 'Objetivo / Nov', width: 'width:140px' },
      { field: 'novGap', header: 'Gap / Nov', width: 'width:120px' },
      { field: 'novPercent', header: '% / Nov', width: 'width:120px' },
      { field: 'dezRealizado', header: 'Realizado / Dez', width: 'width:142px' },
      { field: 'dezObjetivo', header: 'Objetivo / Dez', width: 'width:135px' },
      { field: 'dezGap', header: 'Gap / Dez', width: 'width:120px' },
      { field: 'dezPercent', header: '% / Dez', width: 'width:120px' },
      { field: 'q3Realizado', header: 'Realizado / Q3', width: 'width:142px' },
      { field: 'q3Objetivo', header: 'Objetivo / Q3', width: 'width:135px' },
      { field: 'q3Gap', header: 'Gap / Q3', width: 'width:120px' },
      { field: 'q3Percent', header: '% / Q3', width: 'width:120px' },
      { field: 'janRealizado', header: 'Realizado / Jan', width: 'width:142px' },
      { field: 'janObjetivo', header: 'Objetivo / Jan', width: 'width:135px' },
      { field: 'janGap', header: 'Gap / Jan', width: 'width:120px' },
      { field: 'janPercent', header: '% / Jan', width: 'width:120px' },
      { field: 'fevRealizado', header: 'Realizado / Fev', width: 'width:142px' },
      { field: 'fevObjetivo', header: 'Objetivo / Fev', width: 'width:135px' },
      { field: 'fevGap', header: 'Gap / Fev', width: 'width:120px' },
      { field: 'fevPercent', header: '% / Fev', width: 'width:120px' },
      { field: 'marRealizado', header: 'Realizado / Mar', width: 'width:145px' },
      { field: 'marObjetivo', header: 'Objetivo / Mar', width: 'width:140px' },
      { field: 'marGap', header: 'Gap / Mar', width: 'width:120px' },
      { field: 'marPercent', header: '% / Mar', width: 'width:120px' },
      { field: 'q4Realizado', header: 'Realizado / Q4', width: 'width:142px' },
      { field: 'q4Objetivo', header: 'Objetivo / Q4', width: 'width:135px' },
      { field: 'q4Gap', header: 'Gap / Q4', width: 'width:120px' },
      { field: 'q4Percent', header: '% / Q4', width: 'width:120px' },
    ];

    // Definindo colunas congeladas
    this.frozenCols = [
      { field: 'codDealer', header: 'Dealer' },
      { field: 'nomeDealer', header: 'Nome' }
    ];
  }

  retornaDados() {
    this.loading = true;
    this.service.getDados(`/apuracao_vdm_historico?dataAno=${this.filtros.dataAno}&selecaoVdm=${this.filtros.selecaoVdm}&considerarBalcao=${this.filtros.considerarBalcao}`).subscribe(res => {
      this.dados = res.dados;

      this.totaisHistorico = {
        filtroAno: res.filtroAno,
        totalAbrGap: res.totalAbrGap,
        totalAbrObjetivo: res.totalAbrObjetivo,
        totalAbrPercent: res.totalAbrPercent,
        totalAbrRealizado: res.totalAbrRealizado,
        totalAgoGap: res.totalAgoGap,
        totalAgoObjetivo: res.totalAgoObjetivo,
        totalAgoPercent: res.totalAgoPercent,
        totalAgoRealizado: res.totalAgoRealizado,
        totalDezGap: res.totalDezGap,
        totalDezObjetivo: res.totalDezObjetivo,
        totalDezPercent: res.totalDezPercent,
        totalDezRealizado: res.totalDezRealizado,
        totalFevGap: res.totalFevGap,
        totalFevObjetivo: res.totalFevObjetivo,
        totalFevPercent: res.totalFevPercent,
        totalFevRealizado: res.totalFevRealizado,
        totalJanGap: res.totalJanGap,
        totalJanObjetivo: res.totalJanObjetivo,
        totalJanPercent: res.totalJanPercent,
        totalJanRealizado: res.totalJanRealizado,
        totalJulGap: res.totalJulGap,
        totalJulObjetivo: res.totalJulObjetivo,
        totalJulPercent: res.totalJulPercent,
        totalJulRealizado: res.totalJulRealizado,
        totalJunGap: res.totalJunGap,
        totalJunObjetivo: res.totalJunObjetivo,
        totalJunPercent: res.totalJunPercent,
        totalJunRealizado: res.totalJunRealizado,
        totalMaiGap: res.totalMaiGap,
        totalMaiObjetivo: res.totalMaiObjetivo,
        totalMaiPercent: res.totalMaiPercent,
        totalMaiRealizado: res.totalMaiRealizado,
        totalMarGap: res.totalMarGap,
        totalMarObjetivo: res.totalMarObjetivo,
        totalMarPercent: res.totalMarPercent,
        totalMarRealizado: res.totalMarRealizado,
        totalNovGap: res.totalNovGap,
        totalNovObjetivo: res.totalNovObjetivo,
        totalNovPercent: res.totalNovPercent,
        totalNovRealizado: res.totalNovRealizado,
        totalOutGap: res.totalOutGap,
        totalOutObjetivo: res.totalOutObjetivo,
        totalOutPercent: res.totalOutPercent,
        totalOutRealizado: res.totalOutRealizado,
        totalQ1Gap: res.totalQ1Gap,
        totalQ1Objetivo: res.totalQ1Objetivo,
        totalQ1Percent: res.totalQ1Percent,
        totalQ1Realizado: res.totalQ1Realizado,
        totalQ2Gap: res.totalQ2Gap,
        totalQ2Objetivo: res.totalQ2Objetivo,
        totalQ2Percent: res.totalQ2Percent,
        totalQ2Realizado: res.totalQ2Realizado,
        totalQ3Gap: res.totalQ3Gap,
        totalQ3Objetivo: res.totalQ3Objetivo,
        totalQ3Percent: res.totalQ3Percent,
        totalQ3Realizado: res.totalQ3Realizado,
        totalQ4Gap: res.totalQ4Gap,
        totalQ4Objetivo: res.totalQ4Objetivo,
        totalQ4Percent: res.totalQ4Percent,
        totalQ4Realizado: res.totalQ4Realizado,
        totalSetGap: res.totalSetGap,
        totalSetObjetivo: res.totalSetObjetivo,
        totalSetPercent: res.totalSetPercent,
        totalSetRealizado: res.totalSetRealizado,
      }

      this.loading = false;
    });
  }
}